import { convertNumber } from "utils"
import { BugetManagerMergeListSchema, BugetManagerPayload } from "../types"
import { calculateTotalBudget } from "../utils"

type ItemTotalProps = { 
  item: BugetManagerMergeListSchema 
  list?: BugetManagerMergeListSchema[]
  budgetInputs?: BugetManagerPayload[]
}

export const TableTotalCOA = ({ list, item, budgetInputs }: ItemTotalProps) => {
  const isNormalFontWeight = [3].includes(item.header_level)
  const balance = item.balance[0] ?? null
  const periodKeys = Object.keys(list?.[0]?.period_balance || {})

  return (
    <tr
      key={item?.coa_id + "total"}
      className={balance !== null && balance < 0 ? "text-error" : ""}
    >
      <td>
        <span
          style={{ marginLeft: (item.coa_level - 1) * 24 }}
          className={isNormalFontWeight ? "font-normal" : "font-bold"}>
          {`TOTAL ${item?.coa_name || "-"}`}
        </span>
      </td>

      {item?.balance?.map((balance, index) => (
        <td
          key={balance + index}
          className={`text-right ${isNormalFontWeight ? "font-normal" : "font-bold"}`}>
          {convertNumber(balance).intoCurrency}
        </td>
      ))}

      {periodKeys.map((yearMonth, idx) => {
        const total = calculateTotalBudget(item, list || [], yearMonth, budgetInputs || []);
        return (
          <td key={idx} className={`text-right ${isNormalFontWeight ? "font-normal" : "font-bold"}`}>
            {convertNumber(total).intoCurrency}
          </td>
        )
      })}
    </tr>
  )
}
